import React from "react";

const Redirect = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
	<svg
		width={size}
		style={style}
		height={size}
		viewBox={viewBox}
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={`${className || ""}`}
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<path className="u_fill"
			  d="M14.444 7.333v3.556H5.556v19.555H25.11v-8.888h3.556v10.666A1.778 1.778 0 0126.889 34H3.778A1.778 1.778 0 012 32.222V9.112a1.778 1.778 0 011.778-1.779h10.666zM34 2v16l-6.745-6.743L16.59 21.924l-2.514-2.514L24.741 8.743 18 2h16z"
			  fill={fill}
		/>
	</svg>
);

export default Redirect;
